import type { StrictAppAcquisitionLinkBehavior } from '../types';

export const getAppAcquisitionLinkDefaultBehavior = (): StrictAppAcquisitionLinkBehavior => {
    return {
        __typename: 'AppAcquisitionLinkBehavior',
        linkFormat: 'TextIcon',
    };
};
